import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { useState, useEffect } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { asignarRegla } from "../../services/nomina-reglas-service";
import SelectController from "../../../../core/ui/components/SelectController";

import {
    selectEmpleadosPorRegla,
    selectEmpleadosSinReglasOSecuencias,
} from "../../../../modules/Personas/services/empleados-service";
import { useForm } from "react-hook-form";

const FormAsignarReglas = ({ modalState }) => {
    const [empleados, setEmpleados] = useState([]);
    const defaultValues = {
        empleados: empleados != null ? empleados : [],
    };

    const form = useForm({ defaultValues });

    useEffect(async () => {
        if(modalState.show == false){
            form.setValue('empleados', []);
            return;
        }

        if (modalState.data.idRegla == null) return;

        const [sinReglas, porRegla] = await Promise.all([
            selectEmpleadosSinReglasOSecuencias(modalState.data.idRegla),
            selectEmpleadosPorRegla(modalState.data.idRegla),
        ]);

        sinReglas.status
            ? setEmpleados(sinReglas.data)
            : toast.error(sinReglas.message);

        porRegla.status
            ? form.reset({
                  empleados: porRegla.data.map((emp) => {
                      return {
                          label: emp.info_persona,
                          value: emp.id,
                      };
                  }),
                  idRegla: modalState.data.idRegla,
              })
            : toast.error(porRegla.message);
    }, [modalState.show]);

    const onSubmit = async (data) => {
        const resp = await asignarRegla(
            data.idRegla,
            data.empleados.map((empleado) => empleado.value)
        );

        if (!resp.status) return toast.error(resp.message);
        modalState.set({ show: false });
        form.reset(defaultValues);
        form.setValue('empleados', [])
        toast.success(resp.message);
    };

    return (
        <FormModal
            size="lg"
            form={form}
            isOpen={modalState.show}
            onSubmit={onSubmit}
            id="formAsignarRegla"
            closeModal={() => modalState.set({ show: false })}
            headerTitle="Asignar regla"
        >
            <Row>
                <Col sm={12}>
                    <SelectController
                        errors={form.formState.errors}
                        isMulti={true}
                        control={form.control}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                        label="Empleados"
                        name="empleados"
                        options={empleados.map((empleado) => {
                            return {
                                label: empleado.info_persona,
                                value: empleado.id,
                            };
                        })}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormAsignarReglas.propTypes = {
    modalState: PropTypes.object,
};

export default FormAsignarReglas;
